export default {"src":"/_next/static/media/toggl-hire-logo.b32de3a2.svg","height":23,"width":101};